// extracted by mini-css-extract-plugin
module.exports = {"root":"FormError_root__5C_6R","rotation":"FormError_rotation__SI7y9"};